import React from 'react';
import { useTranslation } from 'next-i18next';
import { SPORT_CATEGORIES } from '@root/src/types';
import { formatEventDate } from '@utils/dates';
import Icon, { ICON_NAME } from '@features/ui/components/Icon';
import {
  Container,
  Footer,
  NameWrapper,
  Section,
  SectionNotVisibleOnMobile,
  SportContainer,
  SerieLabelContainer,
  TagsWrapper,
} from '@features/serieDetail/components/SerieCard/styles';
import SerieLabel from '@features/ui/components/SerieLabel';
import { sportDescriptionMapping, sportIconMapping } from '@features/eventList/components/EventCard';

interface SerieCardRawProps {
  serieCategory: SPORT_CATEGORIES;
  serieType: string;
  name: string;
  year: number
  location: string;
  dateFrom?: string;
  dateTo?: string;
  tags?: React.ReactElement[];
  onClick?: (e: React.SyntheticEvent) => void;
  className?: string;
  footer?: React.ReactElement;
}

export const SerieCardRaw = ({
  serieCategory,
  serieType,
  name,
  year,
  location,
  dateFrom,
  dateTo,
  tags,
  onClick,
  className,
  footer,
}: SerieCardRawProps) => {
  const { t } = useTranslation();

  return (
    <Container
      onClick={onClick}
      className={className}
    >
      <Section>
        <Icon name={sportIconMapping[serieCategory]} size="36px" />
      </Section>
      <NameWrapper>
        <h4>{name}</h4>
        <h3>{year}</h3>
      </NameWrapper>
      <SectionNotVisibleOnMobile>{formatEventDate(null, dateFrom, dateTo, ' ')}</SectionNotVisibleOnMobile>
      <SectionNotVisibleOnMobile>{location}</SectionNotVisibleOnMobile>
      <SectionNotVisibleOnMobile>
        <SportContainer>
          <div>{serieType}</div>
          <div>{t(sportDescriptionMapping[serieCategory])}</div>
        </SportContainer>
      </SectionNotVisibleOnMobile>
      <Section justiyContent="flex-end">
        {onClick && (
          <Icon name={ICON_NAME.arrowForward} color="var(--color-orange)" />
        )}
      </Section>
      <TagsWrapper>
        {tags}
      </TagsWrapper>
      <Footer>{footer}</Footer>
      <SerieLabelContainer>
        <SerieLabel />
      </SerieLabelContainer>
    </Container>
  );
};
